import { CashReceipt } from '../interfaces/payment';
import { brandNameOrDefault, formatBRL, formatDateTimeBR, receiptLogoHtml } from './print-receipt.util';

export interface ComprovanteEspecieOpcoes {
  recibo: CashReceipt;
  usuario: string;
  logo: string;
  cdEmpresa: string;
  marca: string;
  segundaVia?: boolean;
  estornado?: boolean;
  // Digitada pelo operador: não vem do recibo do banco, e é o único registro do motivo.
  observacao?: string | null;
}

function formatarCpf(cpf?: string): string {
  const d = (cpf ?? '').replace(/\D/g, '');
  if (d.length !== 11) return cpf || '—';
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}

export function montarComprovanteEspecie(opcoes: ComprovanteEspecieOpcoes): string {
  const { recibo } = opcoes;
  const linhaCheque = recibo.vlCheque > 0 ? `<tr><td class="label">Cheque</td><td class="value">${formatBRL(recibo.vlCheque)}</td></tr>` : '';
  const linhaCre = recibo.vlCartaoCre > 0 ? `<tr><td class="label">Cartão Crédito</td><td class="value">${formatBRL(recibo.vlCartaoCre)}</td></tr>` : '';
  const linhaDeb = recibo.vlCartaoDeb > 0 ? `<tr><td class="label">Cartão Débito</td><td class="value">${formatBRL(recibo.vlCartaoDeb)}</td></tr>` : '';
  const linhaCpf = recibo.nrCpf ? `<tr><td class="label">CPF</td><td class="value">${formatarCpf(recibo.nrCpf)}</td></tr>` : '';
  const avisoEstorno = opcoes.estornado
    ? `<div class="obs-box" style="text-align:center;font-weight:bold;color:#991b1b;border-color:#991b1b;">ESTORNADO — valor devolvido ao paciente</div>`
    : '';

  return `
    <div class="header">
      <div class="logo">${receiptLogoHtml(opcoes.logo, opcoes.cdEmpresa)}</div>
      <div style="text-align: right;">
        <p class="title">Recibo de Pagamento</p>
        <p class="subtitle">${opcoes.segundaVia ? '2ª via — ' : ''}Pagamento em espécie</p>
        <p class="receipt-number">Nº ${recibo.nrRecibo}</p>
      </div>
    </div>
    ${avisoEstorno}
    <table class="data">
      <tr><td class="label">Pessoa</td><td class="value">${recibo.nmPessoa || '—'}</td></tr>
      ${linhaCpf}
      <tr><td class="label">Data/Hora</td><td class="value">${formatDateTimeBR(recibo.dtRecebimento)}</td></tr>
      <tr><td class="label">Transação</td><td class="value">${recibo.dsTransFin || '—'}</td></tr>
      <tr><td class="label">Usuário</td><td class="value">${opcoes.usuario}</td></tr>
    </table>
    <div class="valor-box">
      <div style="font-size: 10px; color: #626272;">Valor recebido</div>
      <div class="amount">${formatBRL(recibo.vlRecibo)}</div>
      ${recibo.dsValor ? `<div class="extenso">${recibo.dsValor}</div>` : ''}
      ${opcoes.observacao?.trim()
        ? `<div class="obs-box"><strong>Observação:</strong> ${opcoes.observacao.trim()}</div>`
        : ''}
    </div>
    <table class="data" style="margin-top: 10px;">
      <tr><td class="label">Espécie</td><td class="value">${formatBRL(recibo.vlEspecie)}</td></tr>
      ${linhaCheque}
      ${linhaCre}
      ${linhaDeb}
    </table>
    <div class="signature">
      <div class="line"></div>
      <div class="name">Assinatura do responsável</div>
    </div>
    <div class="footer">${brandNameOrDefault(opcoes.marca)}${opcoes.segundaVia ? ' — 2ª via' : ''} — Comprovante sem valor fiscal</div>
  `;
}
